<template>
  <div>
    <template v-if="width < 2054 && width > 1699">
      <vs-row justify="flex-end">
        <vs-col :key="index" v-for="(col, index) in 3" w="2"><br/></vs-col>
      </vs-row>
    </template>
    <vx-card title="병동현황">
      <div class="tb_wrap">
        <div class="text-right">재원 : {{ status_cnt_6+status_cnt_11 }} (입원일 : {{ status_cnt_11 }}) | 퇴원일 : {{ status_cnt_12 }} | 가퇴원 : {{ status_cnt_13 }}</div>
        <div class="text-right">
            3병동 : {{ statusCntWard3 }} |  5병동 : {{ statusCntWard5 }}
        </div>
        <!-- <vs-button type="line" v-bind:class="activeMenu('')" @click="getState('')">전체</vs-button> -->
        
        <div class="">
          <div >
            <vs-button type="line" v-for="(item, index) in menu" :key="index" v-bind:class="activeMenu(item.MEDICAL_ROOM_SEQ)"
                      @click="getState(item.MEDICAL_ROOM_SEQ)">{{
                item.MEDICAL_ROOM_NM
              }}
            </vs-button>
          </div>
          
        </div>
        <br/><br/>
        <div class="tb_box" style="width:100%;overflow-x:auto;height:auto;" v-show="activeMenuCode != '99' && activeMenuCode != '98'">
          <table id="schedule" style="width:100%; max-height:inherit;" class="border-collapse calendar">
            <!-- <colgroup>
                <col width="22%" />
                <col width="5%" />
                <col width="5%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="6%" />
                <col width="22%" />
            </colgroup> -->
            <thead>
            <tr class="fixed_top">
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>병실관련 메모</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>호수</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>베드</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>환자(성별/나이)</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>수정</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>이용상황</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>입원(예정)일</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>퇴원예정일</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" colspan="4"><b>병실이용 대기자</b></th>
              <!-- <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>다음입원 예정일</b></th> -->
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>비고</b></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item, index) in room_reverstion">
              <tr :key="index">
                <!-- <template v-if="item.NEXT_CD == 1"> -->
                <!-- <td class="border border-solid d-theme-border-grey-light text-center p-2 room_memo" style="border-bottom:5px solid #000000;" :rowspan="rowSpan(item.MAX_CNT)"> -->
                <td class="border border-solid d-theme-border-grey-light text-center p-2 room_memo" style="border-bottom:5px solid #000000;">
                  <!-- <vs-textarea class="w-full" name="" label="메모" placeholder="비교 입력해주세요." :id="'memo_' + item.MEDICAL_ROOM_NUMBER_CD" v-model="item.MEMO" /> -->
                  <vx-input-group class="">
                    <vs-input placeholder="입력해주세요." :id="'memo_' + item.MEDICAL_ROOM_NUMBER_CD + item.NEXT_CD" v-model="item.MEMO"/>
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <!-- <vs-button color="primary" @click="memoSave(item.MEDICAL_ROOM_NUMBER_CD)">저장</vs-button> -->
                      </div>
                      <vx-tooltip text="저장" position="top">
                        <vs-button color="primary" icon-pack="feather" icon="icon-save" @click="memoSave(item.MEDICAL_ROOM_NUMBER_CD, item.NEXT_CD)"/>
                      </vx-tooltip>
                    </template>
                  </vx-input-group>
                </td>
                <template v-if="item.NEXT_CD == 1">
                  <td class="border border-solid d-theme-border-grey-light text-center p-2" style="border-bottom:5px solid #000000;"
                      :rowspan="rowSpan(item.MAX_CNT)">
                    <!-- <td class="border border-solid d-theme-border-grey-light text-center p-2" style="border-bottom:5px solid #000000;" :rowspan="rowSpan(item.MAX_CNT)"> -->
                    {{ item.MEDICAL_ROOM_NUMBER_NM }}
                  </td>
                </template>
                <!-- </template> -->

                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" :style="backgroundBg(item.END_TYPE)">
                  #{{ item.NEXT_CD }}
                </td>
                <!-- <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" :style="backgroundBg(item.END_TYPE)">{{ item.MAX_CD }}인실</td> -->
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" :style="backgroundBg(item.END_TYPE)">
                  {{ item.PATIENT_USERNAME }}
                  <template v-if="item.PATIENT_GENDER != '' && item.PATIENT_AGE != ''"> ({{ item.PATIENT_GENDER }}/{{ item.PATIENT_AGE }})</template>
                  <template v-else-if="item.PATIENT_GENDER != '' && item.PATIENT_AGE == ''"> ({{ item.PATIENT_GENDER }})</template>
                  <template v-if="item.PATIENT_GENDER == '' && item.PATIENT_AGE != ''"> {{ item.PATIENT_AGE }})</template>
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" :style="backgroundBg(item.END_TYPE)">
                  <template v-if="item.PATIENT_UID != ''">
                    <vs-button color="primary" size="samll" type="line" icon-pack="feather" icon="icon-edit-2"
                               @click="openModifyPopup(item.PATIENT_UID)"/>
                    <vs-button color="primary" size="samll" type="line" icon-pack="feather" icon="icon-headphones"
                               @click="openModifyPopupCS(item.PATIENT_UID)"/>
                    <vs-button color="primary" size="samll" type="line" icon-pack="feather" icon="icon-calendar"
                               @click="onClickSchedule(item.PATIENT_UID)"/>
                  </template>
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" :style="backgroundBg(item.END_TYPE)">
                  {{ returnReservation(item.END_TYPE) }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" :style="backgroundBg(item.END_TYPE)">
                  {{ item.IN_DATE }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" :style="backgroundBg(item.END_TYPE)">
                  <template v-if="item.OUT_DATE < getToday()"></template>
                  <template v-else>
                    <template v-if="item.OUT_DATE != '2199-12-31'">{{ item.OUT_DATE }}</template>
                  </template>
                </td>
                <!-- <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" :style="backgroundBg(item.END_TYPE)">
                    <vx-tooltip text="상세보기" position="top">
                        <vs-button
                            color="success"
                            size="samll"
                            type="line"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="memberReport(item.MEDICAL_ROOM_NUMBER_CD, item.NEXT_CD)"
                        />
                    </vx-tooltip>
                </td> -->
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  <div class="bl">1순위</div>
                  <div>2순위</div>
                  <div>
                    <vs-button color="primary" size="samll" type="flat" icon-pack="feather" icon="icon-plus" @click="openPopupFun(index)"/>
                  </div>
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  <template v-if="item.PNAME != null">
                    <div class="bl fh">
                      {{
                        item.PNAME.split('|')[0]
                      }}
                      <vs-button
                          color="primary"
                          size="samll"
                          type="flat"
                          icon-pack="feather"
                          icon="icon-edit-2"
                          v-if="item.PUID.split('|')[0] != null"
                          @click="openModifyPopup(item.PUID.split('|')[0])"
                          style="padding:0px;"
                      />
                      <vs-button
                          color="primary"
                          size="samll"
                          type="flat"
                          icon-pack="feather"
                          icon="icon-headphones"
                          v-if="item.PUID.split('|')[0] != null"
                          @click="openModifyPopupCS(item.PUID.split('|')[0])"
                          style="padding:0px;"
                      />
                      <vs-button
                          color="primary"
                          size="samll"
                          type="flat"
                          icon-pack="feather"
                          icon="icon-calendar"
                          v-if="item.PUID.split('|')[0] != null"
                          @click="onClickSchedule(item.PUID.split('|')[0])"
                      />
                    </div>
                    <div class="fh">
                      {{ item.PNAME.split('|')[1] }}
                      <vs-button
                          color="primary"
                          size="samll"
                          type="flat"
                          icon-pack="feather"
                          icon="icon-edit-2"
                          v-if="item.PUID.split('|')[1] != null"
                          @click="openModifyPopup(item.PUID.split('|')[1])"
                          style="padding:0px;"
                      />
                      <vs-button
                          color="primary"
                          size="samll"
                          type="flat"
                          icon-pack="feather"
                          icon="icon-headphones"
                          v-if="item.PUID.split('|')[1] != null"
                          @click="openModifyPopupCS(item.PUID.split('|')[1])"
                          style="padding:0px;"
                      />
                      <vs-button
                          color="primary"
                          size="samll"
                          type="flat"
                          icon-pack="feather"
                          icon="icon-calendar"
                          v-if="item.PUID.split('|')[1] != null"
                          @click="onClickSchedule(item.PUID.split('|')[1])"
                      />
                    </div>
                  </template>
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  <template v-if="item.PIN_DATE != null">
                    <div class="bl fh">
                      {{ item.PIN_DATE.split('|')[0] }}
                    </div>
                    <div class="fh">{{ item.PIN_DATE.split('|')[1] }}</div>
                  </template>
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  <template v-if="item.POUT_DATE != null">
                    <div class="bl fh">
                      {{ item.POUT_DATE.split('|')[0] }}
                    </div>
                    <div class="fh">{{ item.POUT_DATE.split('|')[1] }}</div>
                  </template>
                </td>

                <!-- <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" :style="backgroundBg(item.END_TYPE)">{{ item.RESERVATION_NEXT_NAME }}</td> -->
                <!-- <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" :style="backgroundBg(item.END_TYPE)">{{ item.RESERVATION_NEXT_DATE }}</td> -->
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  <template v-if="item.PATIENT_UID != ''">
                    <!-- <vs-textarea class="w-full" name="" label="비교" placeholder="비교 입력해주세요." :id="item.MEDICAL_ROOM_NUMBER_CD" v-model="item.RESERVATION_MEMO" />
            <vs-button class="mr-3" style="width:100%;" @click="save(item.MEDICAL_ROOM_NUMBER_CD, item.PATIENT_UID)">저장</vs-button> -->
                    <vx-input-group class="">
                      <vs-input placeholder="입력해주세요." :id="'memoetc_' + item.PATIENT_UID" v-model="item.RESERVATION_MEMO"/>
                      <template slot="append">
                        <div class="append-text btn-addon">
                          <!-- <vs-button color="primary" @click="save(item.MEDICAL_ROOM_NUMBER_CD, item.PATIENT_UID)">저장</vs-button> -->
                        </div>
                        <vx-tooltip text="저장" position="bottom">
                          <!-- {{ item.PATIENT_UID }} -->
                          <vs-button color="primary" icon-pack="feather" icon="icon-save"
                                     @click="save(item.MEDICAL_ROOM_NUMBER_CD, item.PATIENT_UID)"/>
                        </vx-tooltip>
                      </template>
                    </vx-input-group>
                  </template>
                </td>
              </tr>
              <!-- <tr :key="index + 1">
                  <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">2순위</td>
                  <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td"></td>
                  <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td"></td>
                  <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td"></td>
              </tr> -->
            </template>
            </tbody>
          </table>
        </div>

        <div class="tb_box" style="width:100%; overflow-x:auto;height:900px;" v-show="activeMenuCode == '99'">
          <div class="vx-row">
            <div class="vx-col w-full xl:w-1/1 mb-base text-center">
              <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="addDate(-7)"></vs-button>
              <span class="ml-5 mr-5"> {{ start_date }} ~ {{ end_date }} </span>
              <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="addDate(7)"></vs-button>
            </div>
          </div>
          <table style="width:100%; max-height:550px;" class="border-collapse">
            <thead>
            <tr>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center summary" colspan="2">구분</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center summary" :class="addClass(index)"
                  v-for="(day, index) in dayList" :key="'day_' + index">
                {{ day }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr class="room1" v-for="(item, index) in roomData1" :key="'room_1_' + index">
              <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" rowspan="3" v-if="index == 0">1인실</td>
              <td
                  class="border border-solid d-theme-border-grey-light text-center p-2 default_td pointer"
                  v-for="(item2, itemIndex) in item"
                  :key="'item_1_' + itemIndex"
                  @click="showEmptyRoom('1', item2.gender, itemIndex - 1)"
              >
                {{ item2.text }}
              </td>
            </tr>
            <tr class="room2" v-for="(item, index) in roomData2" :key="'room_2_' + index">
              <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" rowspan="3" v-if="index == 0">2인실</td>
              <td
                  class="border border-solid d-theme-border-grey-light text-center p-2 default_td pointer"
                  v-for="(item2, itemIndex) in item"
                  :key="'item_2_' + itemIndex"
                  @click="showEmptyRoom('2', item2.gender, itemIndex - 1)"
              >
                {{ item2.text }}
              </td>
            </tr>
            <tr class="room3" v-for="(item, index) in roomData3" :key="'room_3_' + index">
              <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" rowspan="3" v-if="index == 0">3인실</td>
              <td
                  class="border border-solid d-theme-border-grey-light text-center p-2 default_td pointer"
                  v-for="(item2, itemIndex) in item"
                  :key="'item_3_' + itemIndex"
                  @click="showEmptyRoom('3', item2.gender, itemIndex - 1)"
              >
                {{ item2.text }}
              </td>
            </tr>
            <tr class="room4" v-for="(item, index) in roomData4" :key="'room_4_' + index">
              <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td" rowspan="3" v-if="index == 0">4인실</td>
              <td
                  class="border border-solid d-theme-border-grey-light text-center p-2 default_td pointer"
                  v-for="(item2, itemIndex) in item"
                  :key="'item_4_' + itemIndex"
                  @click="showEmptyRoom('4', item2.gender, itemIndex - 1)"
              >
                {{ item2.text }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="tb_box" style="width:100%; overflow-x:auto;height:900px;" v-show="activeMenuCode == '98'">
          <table style="width:100%; max-height:550px;" class="border-collapse">
            <colgroup>
              <col width="80"/>
              <col width="100"/>
              <col width="100"/>
              <col width="100"/>
              <col width="100"/>
              <col width="100"/>
              <col width="100"/>
              <col width="100"/>
              <col width="200"/>
              <col width="100"/>
              <col width="200"/>
            </colgroup>
            <thead>
            <tr>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">이름(나이,성별)</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">주보호자</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">주보호자 연락처</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">본병원</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">입원대기 <br/>등록시간</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">입원예정일</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">희망병실</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">병실관련 메모</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">상담메모</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">기타사항</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item, index) in wait_list">
              <tr :key="index">
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  <!-- <vs-button color="primary" size="samll" type="line" icon-pack="feather" icon="icon-edit-2" @click="openModifyPopup(item.PATIENT_UID)" /> -->
                  <vs-row>
                    <vs-button color="primary" type="line" icon-pack="feather" icon="icon-edit-2" @click="openModifyPopup(item.PATIENT_UID)"/>
                    <vs-button color="primary" type="line" icon-pack="feather" icon="icon-headphones" @click="openModifyPopupCS(item.PATIENT_UID)"/>
                  </vs-row>
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ item.PATIENT_USERNAME }}({{ item.PATIENT_AGE }},{{ item.PATIENT_GENDER }})
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  <template v-if="item.PROTECTOR_NM == '' || item.PROTECTOR_NM == null">본인</template>
                  <template v-else>{{ item.PROTECTOR_NM }}</template>
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ item.MAIN_CALLER_PHONE }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ item.MEDICAL_NAME }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ customFormatter(item.UPDATE_DATETIME) }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ item.IN_DATE }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  <div class="vx-row ">
                    <div class="vx-col " v-for="(t_item, t_index) in roomlist" :key="t_index">
                      <vs-checkbox
                          :checked="returnHosilArray(item.TABSUM).indexOf(t_item.TAB_CODE) > -1"
                          type="checkbox"
                          :vs-value="t_item.TAB_CODE"
                          :id="'tab_01_' + t_index"
                          :disabled="true"
                      >
                        {{ t_item.TAB_NAME }}
                      </vs-checkbox
                      >
                    </div>
                  </div>
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ item.ROOM_MEMO }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ item.CS_MEMO }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ item.MEMO }}
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>

        <!-- 병실 입원예정상황 팝업 시작 -->
        <vs-popup title="병실입원예정" :active.sync="popupActive">
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/1 mb-base">
              <vx-card class="p-2">
                <h5>{{ medical_room }} #{{ bed_num }} 베드</h5>
                <table style="width:100%;" class="border-collapse calendar">
                  <colgroup>
                    <col width="30%"/>
                    <col width="30%"/>
                    <col width="30%"/>
                  </colgroup>
                  <thead>
                  <tr>
                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">환자</th>
                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">이용상황</th>
                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">입원예정일</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(item, index) in patientList">
                    <tr :key="index">
                      <th class="border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_USERNAME }}</th>
                      <td class="border border-solid d-theme-border-grey-light text-center">
                        {{ item.STATUS_NAME }}
                      </td>
                      <td class="border border-solid d-theme-border-grey-light text-center">{{ item.IN_DATE }}</td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </vx-card>
            </div>
          </div>
        </vs-popup>
        <!-- 병실 입원예정상황 팝업 끝 -->
        <!-- 비어있는 병실 -->
        <!-- <vs-popup :title="'남은 병실 보기(' + emptyRoomCnt + ')(' + searchDate + ')'" :active.sync="roomPopup"> -->
        <vs-popup :title="'남은 병실 보기(' + searchDate + ')'" :active.sync="roomPopup">
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/1">
              <!-- <vx-card class="p-2"> -->
              <div class="text-center" v-show="emptyRoomData.length > 0">
                <table style="width:100%; max-height:550px;" class="border-collapse">
                  <colgroup>
                    <col width="10%"/>
                    <col width="10%"/>
                    <col width="20%"/>
                    <col width="20%"/>
                    <col width="10%"/>
                    <col width="30%"/>
                  </colgroup>
                  <thead>
                  <tr>
                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">병실</th>
                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">베드</th>
                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">다음예약</th>
                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">예약자</th>
                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">성별</th>
                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">병실관련 메모</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in emptyRoomData" :key="'empty_' + index">
                    <td class="border border-solid d-theme-border-grey-light text-center p-2 h-2">{{ item.MEDICAL_ROOM_NUMBER_NM }}</td>
                    <td class="border border-solid d-theme-border-grey-light text-center">{{ item.NEXT_CD }}</td>
                    <td class="border border-solid d-theme-border-grey-light text-center">
                      <template v-if="item.DETAIL_INFO == null"> -</template>
                      <template v-else>{{ item.DETAIL_INFO.split('///')[1] }}</template>
                    </td>
                    <td class="border border-solid d-theme-border-grey-light text-center">
                      <template v-if="item.DETAIL_INFO == null"> -</template>
                      <template v-else
                      >{{ item.DETAIL_INFO.split('///')[0] }}
                        <!--
                        <vs-button
                            color="primary"
                            size="samll"
                            type="line"
                            icon-pack="feather"
                            icon="icon-edit-2"
                            @click="openModifyPopup(item.DETAIL_INFO.split('///')[2])"
                        />-->
                        <vs-row>
                          <vs-col :w="10">
                            <vs-button color="primary" type="line" icon-pack="feather" icon="icon-edit-2"
                                       @click="openModifyPopup(item.DETAIL_INFO.split('///')[2])"/>
                            <vs-button
                                color="primary"
                                type="line"
                                icon-pack="feather"
                                icon="icon-headphones"
                                @click="openModifyPopupCS(item.DETAIL_INFO.split('///')[2])"
                            />
                          </vs-col>
                        </vs-row>
                      </template>
                    </td>
                    <td class="border border-solid d-theme-border-grey-light text-center">
                      <template v-if="item.DETAIL_INFO == null"> -</template>
                      <template v-else>{{ item.DETAIL_INFO.split('///')[3] }}</template>
                    </td>
                    <td class="border border-solid d-theme-border-grey-light text-center">{{ item.ROOM_MEMO }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-center" v-show="emptyRoomData.length == 0">
                <p class="text-gray">데이터가 없습니다.</p>
              </div>
              <!-- </vx-card> -->
            </div>
          </div>
        </vs-popup>
        <!-- 비어있는 병실 -->
      </div>
    </vx-card>

    <vs-popup title="병실 대기자 현황" :active.sync="openPopup" id="admin_popup">
      <div class="vx-row mb-6">
        <div class="vx-col w-full text-center">
          <h5 v-text="select_room_reverstion.MEDICAL_ROOM_NUMBER_NM"></h5>
        </div>
      </div>
      <vs-divider></vs-divider>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <h5 class="mb-6">입원</h5>

          <table id="schedule" style="width:100%; max-height:550px;" class="border-collapse calendar">
            <thead>
            <tr class="fixed_top">
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>환자(성별/나이)</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>입원(예정)일</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>퇴원예정일</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td"
                  :style="backgroundBg(select_room_reverstion.END_TYPE)">
                {{ select_room_reverstion.PATIENT_USERNAME }}
                <template v-if="select_room_reverstion.PATIENT_GENDER != '' && select_room_reverstion.PATIENT_AGE != ''">
                  ({{ select_room_reverstion.PATIENT_GENDER }}/{{ select_room_reverstion.PATIENT_AGE }})
                </template>
                <template v-else-if="select_room_reverstion.PATIENT_GENDER != '' && select_room_reverstion.PATIENT_AGE == ''">
                  ({{ select_room_reverstion.PATIENT_GENDER }})
                </template>
                <template v-if="select_room_reverstion.PATIENT_GENDER == '' && select_room_reverstion.PATIENT_AGE != ''">
                  {{ select_room_reverstion.PATIENT_AGE }})
                </template>
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td"
                  :style="backgroundBg(select_room_reverstion.END_TYPE)">
                {{ select_room_reverstion.IN_DATE }}
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td"
                  :style="backgroundBg(select_room_reverstion.END_TYPE)">
                <template v-if="select_room_reverstion.OUT_DATE < getToday()"></template>
                <template v-else>
                  <template v-if="select_room_reverstion.OUT_DATE != '2199-12-31'">{{ select_room_reverstion.OUT_DATE }}</template>
                </template>
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td"
                  :style="backgroundBg(select_room_reverstion.END_TYPE)">
                <template v-if="select_room_reverstion.PATIENT_UID != ''">
                  <vs-button color="primary" size="samll" type="line" icon-pack="feather" icon="icon-edit-2"
                             @click="openModifyPopup(select_room_reverstion.PATIENT_UID)"/>
                  <vs-button color="primary" size="samll" type="line" icon-pack="feather" icon="icon-headphones"
                             @click="openModifyPopupCS(select_room_reverstion.PATIENT_UID)"/>
                  <vs-button color="primary" size="samll" type="line" icon-pack="feather" icon="icon-calendar"
                             @click="onClickSchedule(select_room_reverstion.PATIENT_UID)"/>
                </template>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <vs-divider></vs-divider>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <h5 class="mb-6">대기</h5>

          <table id="schedule" style="width:100%; max-height:550px;" class="border-collapse calendar">
            <thead>
            <tr class="fixed_top">
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>환자(성별/나이)</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>입원(예정)일</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>퇴원예정일</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"><b>병실</b></th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item, index) in select_room_reverstion.wait_list">
              <tr :key="index">
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ item.pname }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ item.pin_date }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ item.pout_date }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  {{ item.room }}
                </td>
                <td class="border border-solid d-theme-border-grey-light text-center p-2 default_td">
                  <div class="bl fh">
                    <vs-button
                        color="primary"
                        size="samll"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-edit-2"
                        v-if="item.puid != null"
                        @click="openModifyPopup(item.puid)"
                        style="padding:0px;"
                    />
                    <vs-button
                        color="primary"
                        size="samll"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-headphones"
                        v-if="item.puid != null"
                        @click="openModifyPopupCS(item.puid)"
                        style="padding:0px;"
                    />
                    <vs-button
                        color="primary"
                        size="samll"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-calendar"
                        v-if="item.puid != null"
                        @click="onClickSchedule(item.puid)"
                    />
                  </div>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="warning" type="border" class="mb-2" @click="openPopup = false">닫기</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import $ from 'jquery';
import axiosClass from '@/../util/axiosClass';
import {EventBus} from '@/../util/vue-event-bus';
import moment from 'moment';
// import Textarea from '../../../../../../../CM/Vue-TEMPLATE/elite-vuesax-vuejs-starterkit/src/views/components/vuesax/textarea/textarea.vue';

export default {
  data() {
    return {
      popupActive: false,
      room_reverstion: [],
      patientList: [],
      medical_room: '',
      bed_num: '',
      menu: [],
      activeMenuCode: '',
      status_cnt_6: 0,
      status_cnt_11: 0,
      status_cnt_12: 0,
      status_cnt_13: 0,
      width: window.innerWidth,
      start_date: '',
      end_date: '',
      date_cnt: 7,
      dayList: [],
      roomData1: [],
      roomData2: [],
      roomData3: [],
      roomData4: [],
      emptyRoomData: [],
      emptyRoomCnt: 0,
      roomPopup: false,
      dayListYMD: [],
      wait_list: [],
      searchDate: '',
      roomlist: [],
      tabArray_01: [],
      openPopup: false,
      select_room_reverstion: {},
      statusCntWard3: 0,
      statusCntWard5: 0,
    };
  },
  methods: {
    handleResize(event) {
      this.width = window.innerWidth;
    },
    onClickSchedule(uid) {
      this.$router.push("/patientSchedule/scheduleCalendar/" + uid);
    },
    async openPopupFun(index = 9999) {
      if (index == 9999) {

      } else {
        const item = this.room_reverstion[index];
        item.wait_list = [];

        if (item.PNAME) {
          const split = item.PNAME.split('|');
          for (let i = 0; i < split.length; i++) item.wait_list[i] = {
            ...item.wait_list[i],
            pname : split[i]
          };
        }
        if (item.PUID) {
          const split = item.PUID.split('|');
          for (let i = 0; i < split.length; i++) item.wait_list[i] = {
            ...item.wait_list[i],
            puid : split[i]
          };
        }
        if (item.PIN_DATE) {
          const split = item.PIN_DATE.split('|');
          for (let i = 0; i < split.length; i++) item.wait_list[i] = {
            ...item.wait_list[i],
            pin_date : split[i]
          };
        }
        if (item.POUT_DATE) {
          const split = item.POUT_DATE.split('|');
          for (let i = 0; i < split.length; i++) item.wait_list[i] = {
            ...item.wait_list[i],
            pout_date : split[i]
          };
        }
        if (item.PUPDATE_DATETIME) {
          const split = item.PUPDATE_DATETIME.split('|');
          for (let i = 0; i < split.length; i++) item.wait_list[i] = {
            ...item.wait_list[i],
            pupdate_datetime : split[i]
          };
        }

        item.wait_list.map(i => i.room = `${item.MEDICAL_ROOM_NUMBER_NM} - ${item.NEXT_CD}`);
        item.wait_list = item.wait_list.sort((a, b) => new Date(a.pupdate_datetime) - new Date(b.pupdate_datetime));
        this.select_room_reverstion = item;
      }

      this.openPopup = true;
    },
    async getState(medical_room_number) {
      const jsonData = {
        medical_room_number: medical_room_number,
      };

      this.activeMenuCode = medical_room_number;
      if (this.activeMenuCode != '99') {
        const {data} = await axiosClass.get('/api/ward/status', jsonData);
        this.room_reverstion = data.list;

        this.status_cnt_6 = data.status_cnt_6;
        this.status_cnt_11 = data.status_cnt_11;
        this.status_cnt_12 = data.status_cnt_12;
        this.status_cnt_13 = data.status_cnt_13;
        this.statusCntWard3 = data.statusCntWard3;
        this.statusCntWard5 = data.statusCntWard5;

        this.menu = data.tab_menu;
        this.menu.unshift({MEDICAL_ROOM_NM: '전체', MEDICAL_ROOM_SEQ: ''});
        this.menu.unshift({MEDICAL_ROOM_NM: '요약', MEDICAL_ROOM_SEQ: '99'});
        this.menu.push({MEDICAL_ROOM_NM: '입원대기', MEDICAL_ROOM_SEQ: '98'});
        this.roomlist = data.roomlist;
        console.log('this.roomlist:::', this.roomlist);
        this.wait_list = data.waitList;
        console.log('this.wait_list:::', this.wait_list);
      } else {
        this.roomData1 = [];
        this.roomData2 = [];
        this.roomData3 = [];
        this.roomData4 = [];
        this.dayList = [];
        const {data} = await axiosClass.get(`/api/ward/summary/${this.start_date}/${this.date_cnt}`);

        this.status_cnt_6 = data.status_cnt_6;
        this.status_cnt_11 = data.status_cnt_11;
        this.status_cnt_12 = data.status_cnt_12;
        this.status_cnt_13 = data.status_cnt_13;
        this.statusCntWard3 = data.statusCntWard3;
        this.statusCntWard5 = data.statusCntWard5;
        this.roomData1 = [[{text: '성별무관'}], [{text: '남성'}], [{text: '여성'}]];
        this.roomData2 = [[{text: '성별무관'}], [{text: '남성'}], [{text: '여성'}]];
        this.roomData3 = [[{text: '성별무관'}], [{text: '남성'}], [{text: '여성'}]];
        this.roomData4 = [[{text: '성별무관'}], [{text: '남성'}], [{text: '여성'}]];
        this.menu = data.tab_menu;
        this.setDayList();
        this.menu.unshift({MEDICAL_ROOM_NM: '전체', MEDICAL_ROOM_SEQ: ''});
        this.menu.unshift({MEDICAL_ROOM_NM: '요약', MEDICAL_ROOM_SEQ: '99'});
        this.menu.push({MEDICAL_ROOM_NM: '입원대기', MEDICAL_ROOM_SEQ: '98'});

        Object.keys(data).filter(key => {
          if (key.indexOf('room') > -1) {
            const roomData = data[key];
            for (let i = 0; i < roomData.length; i++) {
              const item = roomData[i];
              if (item.room_number == '1') {
                if (item.room_gender == '0') this.roomData1[0].push({text: item.empty_count, gender: item.room_gender});
                if (item.room_gender == 'M') this.roomData1[1].push({text: item.empty_count, gender: item.room_gender});
                if (item.room_gender == 'F') this.roomData1[2].push({text: item.empty_count, gender: item.room_gender});
              } else if (item.room_number == '2') {
                if (item.room_gender == '0') this.roomData2[0].push({text: item.empty_count, gender: item.room_gender});
                if (item.room_gender == 'M') this.roomData2[1].push({text: item.empty_count, gender: item.room_gender});
                if (item.room_gender == 'F') this.roomData2[2].push({text: item.empty_count, gender: item.room_gender});
              } else if (item.room_number == '3') {
                if (item.room_gender == '0') this.roomData3[0].push({text: item.empty_count, gender: item.room_gender});
                if (item.room_gender == 'M') this.roomData3[1].push({text: item.empty_count, gender: item.room_gender});
                if (item.room_gender == 'F') this.roomData3[2].push({text: item.empty_count, gender: item.room_gender});
              } else if (item.room_number == '4') {
                if (item.room_gender == '0') this.roomData4[0].push({text: item.empty_count, gender: item.room_gender});
                if (item.room_gender == 'M') this.roomData4[1].push({text: item.empty_count, gender: item.room_gender});
                if (item.room_gender == 'F') this.roomData4[2].push({text: item.empty_count, gender: item.room_gender});
              }
            }
          }
        });
      }
    },
    async memoSave(cd, bed_id) {
      const value = document.getElementById('memo_' + cd + bed_id).value;
      const jsonData = {
        memo: value,
      };

      await axiosClass.put('/api/ward/hospitalMemo/' + cd + '/' + bed_id, jsonData);
      this.$vs.notify({
        title: 'Success',
        text: '정상적으로 등록되었습니다.',
        color: 'success',
        position: 'top-right',
        iconPack: 'feather',
        icon: 'icon-check',
      });
    },
    async save(cd, uid) {
      const value = document.getElementById('memoetc_' + uid).value;
      console.log(cd);
      console.log(uid);
      console.log(value);
      const jsonData = {
        memo: value,
      };
      console.log(jsonData);
      await axiosClass.put('/api/ward/memo/' + uid, jsonData);
      this.$vs.notify({
        title: 'Success',
        text: '정상적으로 등록되었습니다.',
        color: 'success',
        position: 'top-right',
        iconPack: 'feather',
        icon: 'icon-check',
      });
    },
    returnReservation(gubun) {
      let gubunString = '';
      switch (gubun) {
        case '1':
          gubunString = '재원';
          break;
        case '2':
          gubunString = '입원예약';
          break;
        case '3':
          gubunString = '퇴원예정';
          break;
        case '5':
          gubunString = '가퇴원';
          break;
        case '6':
          gubunString = '입원일';
          break;
        case '7':
          gubunString = '퇴원일';
          break;
      }
      return gubunString;
    },
    reservationDate(item) {
      let date = '';

      switch (item.END_TYPE) {
        case '1':
          date = '';
          break;
        case '2':
          date = item.IN_DATE;
          break;
        case '3':
          date = item.OUT_DATE;
          break;
        case '5':
          date = item.IN_DATE;
          break;
      }
      return date;
    },
    rowSpan(max) {
      let max_data = parseInt(max);
      return max_data;
    },

    activeMenu(medical_code) {
      if (medical_code == this.activeMenuCode) {
        return 'activeMenu';
      } else {
        return '';
      }
    },

    backgroundBg(gubun) {
      let style = '';
      switch (gubun) {
        case '1':
          style = 'background-color:rgba(255,242,204,0.3)';
          break;
        case '2':
          style = 'background-color:rgba(183,215,168,0.3)';
          break;
        case '3':
          break;
        case '4':
          style = 'background-color:rgba(180,167,214,0.3)';
          break;
        case '5':
          style = 'background-color:rgba(241,1947,50,0.3)';
          break;
      }

      return style;
    },
    // async memberReport(medical_room_number_cd, bed_num) {
    //     console.log(medical_room_number_cd + '////' + bed_num);
    //     let params = {
    //         medical_room_number_cd: medical_room_number_cd,
    //         medical_room_number_cnt: bed_num,
    //     };
    //     console.log(params);
    //     const { data } = await axiosClass.put('/api/ward/situation', params, true);
    //     console.log(data);
    //     this.popupActive = true;
    //     this.patientList = data;
    //     this.medical_room = this.patientList[0].MEDICAL_ROOM_NUMBER_NM;
    //     this.bed_num = bed_num;
    //     console.log(data);
    // },

    async addDate(num) {
      let today = new Date();
      const todayString = this.getDateString(today);
      if (this.start_date == todayString && num < 0) {
        return false;
      }
      today = new Date(this.start_date);
      today.setDate(today.getDate() + num);
      this.start_date = this.getDateString(today);
      today.setDate(today.getDate() + 6);
      this.end_date = this.getDateString(today);
      await this.getState('99');
    },
    setDayList() {
      this.dayList = [];
      this.dayListYMD = [];
      let today = new Date(this.start_date);
      for (let i = 0; i < this.date_cnt; i++) {
        const pushMonth = String(today.getMonth() + 1).length == 1 ? '0' + String(today.getMonth() + 1) : String(today.getMonth() + 1);
        const pushDate = String(today.getDate()).length == 1 ? '0' + String(today.getDate()) : String(today.getDate());
        const numDay = today.getDay();
        let pushDay = '';
        switch (numDay) {
          case 0:
            pushDay = '일요일';
            break;
          case 1:
            pushDay = '월요일';
            break;
          case 2:
            pushDay = '화요일';
            break;
          case 3:
            pushDay = '수요일';
            break;
          case 4:
            pushDay = '목요일';
            break;
          case 5:
            pushDay = '금요일';
            break;
          case 6:
            pushDay = '토요일';
            break;
        }
        this.dayList.push(pushMonth + '/' + pushDate + ' ' + pushDay);
        this.dayListYMD.push(this.getDateString(today));
        today.setDate(today.getDate() + 1);
      }
    },

    async showEmptyRoom(gubun, gender, index) {
      if (gender == undefined) return;

      const date = new Date(this.start_date);
      date.setDate(date.getDate() + index);
      const searchDate = this.getDateString(date);
      this.searchDate = searchDate;
      const {data} = await axiosClass.get(`/api/ward/summary/detail/${gubun}/${gender}/${searchDate}`);
      this.emptyRoomData = data.roomData;

      this.emptyRoomCnt = this.emptyRoomData.length;

      this.roomPopup = true;
    },
    getDateString(date) {
      return (
          date.getFullYear() +
          '-' +
          (String(date.getMonth() + 1).length == 1 ? '0' + String(date.getMonth() + 1) : String(date.getMonth() + 1)) +
          '-' +
          (String(date.getDate()).length == 1 ? '0' + String(date.getDate()) : String(date.getDate()))
      );
    },
    addClass(index) {
      const today = new Date();
      const date = this.getDateString(today);
      if (date == this.dayListYMD[index]) {
        return 'now';
      } else {
        return '';
      }
    },
    async openModifyPopup(uid) {
      this.$EventBus.$emit('memberView', uid);
    },
    async openModifyPopupCS(uid) {
      this.$EventBus.$emit('memberCs', uid);
    },
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    returnHosilText(tabsum) {
      let result = '';
      for (let i = 0; i < this.roomlist.length; i++) {
        if ((tabsum & this.roomlist[i].TAB_CODE) != false) {
          if (result == '') result += this.roomlist[i].TAB_NAME;
          else result += ', ' + this.roomlist[i].TAB_NAME;
        }
      }
      return result;
    },
    returnHosilArray(tabsum) {
      console.log('tabsum:::', tabsum);
      let result = [];
      for (let i = 0; i < this.roomlist.length; i++) {
        if ((tabsum & this.roomlist[i].TAB_CODE) != false) {
          result.push(this.roomlist[i].TAB_CODE);
        }
      }
      return result;
    },
    getToday() {
      const today = new Date();
      return (
          today.getFullYear()
          + '-'
          + (String(today.getMonth() + 1).length == 1 ? '0' + String(today.getMonth() + 1) : String(today.getMonth() + 1))
          + '-'
          + (String(today.getDate()).length == 1 ? '0' + String(today.getDate()) : String(today.getDate()))
      );
    },
  },

  async mounted() {
    window.addEventListener('resize', this.handleResize);
    await this.getState('99');

    EventBus.$on('remoteListRefresh', async () => {
      await this.getState(this.activeMenuCode);
    });

    EventBus.$on('remoteListCsRefresh', async () => {
      await this.getState(this.activeMenuCode);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  created() {
    const today = new Date();
    this.start_date = this.getDateString(today);
    today.setDate(today.getDate() + 6);
    this.end_date = this.getDateString(today);
  },
};
</script>

<style>
.room_memo {
  background-color: #fff;
}

.room_number {
  background-color: #fde0ff;
}

.default_td {
  height: 20px;
}

.tb_box {
  height: 630px;
  overflow: auto;
}

.table_header {
  position: sticky;
  top: 0;
  z-index: 100;
}

.bl {
  border-bottom: 1px dotted #ccc !important;
  margin: 0px !important;
}

.fh {
  height: 35px;
}

.activeMenu {
  border-color: #015666;
}

.includeIcon {
  display: initial;
}

.room1 > td {
  background-color: rgb(220, 233, 213);
}

.room2 > td {
  background-color: rgb(211, 223, 226);
}

.room3 > td {
  background-color: rgb(238, 206, 205);
}

.room4 > td {
  background-color: rgb(253, 242, 208);
}

.pointer {
  cursor: pointer;
}

.summary {
  background-color: rgb(255, 255, 255);
}

.now {
  background-color: rgb(67, 151, 152);
  color: rgb(255, 255, 255);
}
.fixed_top {
    position: sticky;
    top: 0;
}
.tb_box::-webkit-scrollbar {
  display: none;
}
</style>
